export default class SafeLocalStorage {
	public static setItem(key: string, value: any, overwrite?: boolean) {
		if (!overwrite && localStorage.getItem(key)) {
			throw new Error('This operation would overwrite an existing seed!')
		} else {
			localStorage.setItem(key, value)
		}
	}

	public static getItem(key: string): any {
		return localStorage.getItem(key)
	}

	public static removeItem(key: string) {
		localStorage.removeItem(key)
	}
}
